import { render, staticRenderFns } from "./BestEmployeeList.vue?vue&type=template&id=4267a32c&scoped=true&"
import script from "./BestEmployeeList.vue?vue&type=script&lang=js&"
export * from "./BestEmployeeList.vue?vue&type=script&lang=js&"
import style0 from "./BestEmployeeList.vue?vue&type=style&index=0&id=4267a32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267a32c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VImg,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSubheader})
